import MuiInputAdornment, { type InputAdornmentProps } from "@mui/material/InputAdornment";

export type { InputAdornmentProps };

export function InputAdornment(props: InputAdornmentProps) {
  return <MuiInputAdornment {...props} />;
}
